export const FUNNOW_BREAKPOINTS = {
  xs: 600,
  sm: 768,
  md: 960,
  lg: 1280,
  xl: 1536,
}
export const LEGACY_LG_BREAKPOINT = 1120

export const Z_INDEX = {
  smartBannerMobile: 15,
  categoryInfoMobile: 15,
  regionListContainer: 15,
  searchBarMobile: 100,
  alert: 90000,
}

export const CUSTOM_COLORS = {
  gray20: '#f4f4f5',
  gray30: '#f4f4f5', // FIXME: not the same as color in FunNow library
  gray40: '#dbdbdb',
  gray50: '#c1c1c2',
  gray60: '#a7a7a9',
  gray80: '#747476',
  black50: '#252729',
  orange10: '#ffeeeb',
  orange20: '#ffd8d1',
  orange30: '#ffad9e',
  orange40: '#ff816b',
  orange50: '#ff5537',
  orange60: '#ff2a05',
  orange70: '#d21f00',
  purple50: '#5a69eb',
  purple60: '#2e41e6',
  yellow10: '#fff1d1',
  yellow20: '#ffe19e',
  yellow50: '#ffb107',
  yellow60: '#d18f00',
  green20: '#ebf5f1',
  green30: '#4dcbcb',
  green50: '#34b2b2',
  green70: '#4d947c',
  red20: '#e6b3b5',
  red50: '#c03f45',
  pink20: '#E8E3E3',
  pink30: '#d1c7c7',
  pink40: '#BAABAB',
  pink60: '#8C7373',
  brown60: '#a78768',
  brown50: '#b9a087',
  brown20: '#F2EDE8',
  blue60: '#468196',
  blue50: '#5b9cb3',
  eliteColor: '#a38f8f',
  proColor: '#b9a087',
  seekerColor: '#ff816b',
}
